var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-tile-macro.j2"] = require( "macros/product-tile-macro.j2" );
dependencies["macros/slider-macros.j2"] = require( "macros/slider-macros.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/ugc-tray-carousel.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-tile-macro.j2", false, "core/templates/contentful/ugc-tray-carousel.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayProductTile")) {
var t_4 = t_1.displayProductTile;
} else {
cb(new Error("cannot import 'displayProductTile'")); return;
}
context.setVariable("displayProductTile", t_4);
env.getTemplate("macros/slider-macros.j2", false, "core/templates/contentful/ugc-tray-carousel.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("create_slider_arrows")) {
var t_8 = t_5.create_slider_arrows;
} else {
cb(new Error("cannot import 'create_slider_arrows'")); return;
}
context.setVariable("create_slider_arrows", t_8);
var t_9;
t_9 = (lineno = 3, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "isFeatureEnabled"), "isFeatureEnabled", context, [runtime.contextOrFrameLookup(context, frame, "core"),"favorites"]));
frame.set("displayFavorites", t_9, true);
if(frame.topLevel) {
context.setVariable("displayFavorites", t_9);
}
if(frame.topLevel) {
context.addExport("displayFavorites", t_9);
}
var t_10;
t_10 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"tileOptions")),"default_ugc_carousel_tile_template");
frame.set("defaultUgcCarouselTileTemplate", t_10, true);
if(frame.topLevel) {
context.setVariable("defaultUgcCarouselTileTemplate", t_10);
}
if(frame.topLevel) {
context.addExport("defaultUgcCarouselTileTemplate", t_10);
}
output += "<div class=\"s-ugc\">";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugc")),"tray")),"products") != "") {
output += "<div class=\"c-ugc-tray-carousel\">\n\n            <div class=\"o-row\">\n\n                <div class=\"o-column o-extra-small--12 o-slider__heading\">\n\n                    <h2 class=\"o-slider__h2\">\n\n                        ";
output += runtime.suppressValue((lineno = 18, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc_associated-products-label",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n\n                    </h2>\n\n                </div>\n\n            </div>\n\n            <div class=\"o-row\">\n\n                <div class=\"o-column o-extra-small--12 o-slider__wrapper\">\n\n                    <div class=\"o-slider o-slider--ugc-product-image js-slider--product-image u-centered-content\" data-qa-ugc-carousel>\n\n                        <div class=\"o-slider__inner js-slider__inner\">\n\n                            ";
output += "\n                            ";
frame = frame.push();
var t_13 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugc")),"tray")),"products");
if(t_13) {var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("product", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
output += "\n\n                                <div class=\"o-slider__slide o-slider__slide--product-image js-slider__slide\">\n\n                                    ";
var t_15;
t_15 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"imagePresets")),"productTileSmallImagePreset");
frame.set("imagePreset", t_15, true);
if(frame.topLevel) {
context.setVariable("imagePreset", t_15);
}
if(frame.topLevel) {
context.addExport("imagePreset", t_15);
}
output += "\n                                    ";
var t_16;
t_16 = (lineno = 40, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","ugc tray",runtime.memberLookup((runtime.memberLookup((t_14),"product")),"productSlug")]));
frame.set("analytics", t_16, true);
if(frame.topLevel) {
context.setVariable("analytics", t_16);
}
if(frame.topLevel) {
context.addExport("analytics", t_16);
}
output += "\n                                    ";
var t_17;
t_17 = (lineno = 41, colno = 64, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","ugc tray",runtime.memberLookup((runtime.memberLookup((t_14),"product")),"productSlug") + " quickshop"]));
frame.set("analyticsQuickShop", t_17, true);
if(frame.topLevel) {
context.setVariable("analyticsQuickShop", t_17);
}
if(frame.topLevel) {
context.addExport("analyticsQuickShop", t_17);
}
output += "\n\n                                    ";
output += runtime.suppressValue((lineno = 43, colno = 55, runtime.callWrap(t_4, "displayProductTile", context, [runtime.memberLookup((t_14),"product"),runtime.makeKeywordArgs({"productIndex": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),"tileTemplate": runtime.contextOrFrameLookup(context, frame, "defaultUgcCarouselTileTemplate"),"displayFavorites": runtime.contextOrFrameLookup(context, frame, "displayFavorites"),"imagePreset": runtime.contextOrFrameLookup(context, frame, "imagePreset"),"analytics": runtime.contextOrFrameLookup(context, frame, "analytics"),"analyticsQuickShop": runtime.contextOrFrameLookup(context, frame, "analyticsQuickShop")})])), env.opts.autoescape);
output += "\n\n                                </div>";
;
}
}
frame = frame.pop();
output += "</div>\n\n                    </div>\n\n                    ";
output += runtime.suppressValue((lineno = 53, colno = 41, runtime.callWrap(t_8, "create_slider_arrows", context, [runtime.makeKeywordArgs({"disablePrev": runtime.contextOrFrameLookup(context, frame, "True"),"isSmallArrow": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
output += "\n\n                </div>\n\n            </div>\n\n        </div>";
;
}
output += "</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/ugc-tray-carousel.j2"] , dependencies)